<template>
  <div class="form-group background-content-wrapper" v-click-outside="bgContentDeselected">
    <label>Background Content</label>

    <draggable
      v-model="editableBgContent"
      v-bind="dragOptions"
      class="background-content-list"
      @end="updateBgContent"
    >
      <div 
        v-for="(background, index) in editableBgContent" 
        :key="index" 
        class="background-content"
        :class="{'background-content--no-bg' : background.image === ''}"
        :style="background.image !== '' ? `background-image: url(${$store.state.assetsPath}` + convertToThumbnail(background.image) + ')' : ''"
        @click="bgContentSelected($event, background)"
      >
        <div class="heading" v-html="background.heading[lang]"></div>
      </div>
    </draggable>

    <button type="button" class="btn btn-secondary" @click="addBgContent">
      Add Background
    </button>

    <!-- popup modal for background content -->
    <modal-edit-box 
      :isVisible="isBgContentSelected"
      :isArrowVisible="true"
      :xPos="modalData.assetSelected.xPos"
      :yPos="modalData.assetSelected.yPos"
      @update="updateBgContent"
      @remove="removeBgContent(modalData.assetSelected.content._id)"
    >
      <fieldset slot="input" class="form-group form-group--sm">
        <label class="modal-label">Heading</label>
        <input
          v-if="modalData.assetSelected.content.heading"
          v-model="modalData.assetSelected.content.heading[lang]"
          type="text"
          class="form-control form-control-lg"
          placeholder="heading"
        />
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm mb-1">
        <input
          v-if="modalData.assetSelected.content.image"
          v-model="$store.state.assetsPath + modalData.assetSelected.content.image"
          type="text"
          class="form-control form-control-lg"
          placeholder="no image attached"
          readonly
        />
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm">
        <button
          class="btn btn-secondary btn-block btn-sm"
          @click="openAssetLibrary"
        >Attach Image</button>
      </fieldset>
      <fieldset slot="input" class="form-group form-group--sm">
        <button
          class="btn btn-danger btn-block btn-sm"
          @click="removeAsset"
        >Remove Image</button>
      </fieldset>
    </modal-edit-box>
    <!-- popup modal -->

    <asset-library
      v-if="isLibraryVisible"
      v-model="libraryModel"
      :multiple="false"
      defaultCategory="pageBackground"
      @close="closeAssetLibrary"
    ></asset-library>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import AssetLibrary from '@/components/NewAssetLibrary'

export default {
  name: 'page-bg-content',

  components: {
    draggable,
    AssetLibrary
  },

  props: {
    bgContent: Array,
    dir: String,
    lang: String
  },

  data() {
    return {
      editableBgContent: this.bgContent,

      isBgContentSelected: false,

      modalData: {
        assetSelected: {
          content: {}
        }
      },

      isLibraryVisible: false,
      libraryModel: null
    }
  },

  watch: {
    libraryModel () {
      if (this.libraryModel) {
        this.modalData.assetSelected.content.image = this.libraryModel.path
      }
    },

    assets () {
      this.initLibraryModel()
    },

    value () {
      if (this.libraryModel) {
        if (this.multiple) {
          const libraryModelPaths = JSON.stringify(this.libraryModel.map(asset => {
            return asset.path
          }))
          const valuePaths = JSON.stringify(this.value)
          if (libraryModelPaths !== valuePaths) {
            this.initLibraryModel ()
          }
        } else {
          if (this.value !== this.libraryModel.path) {
            this.initLibraryModel ()
          }
        }
      } else {
        this.initLibraryModel()
      }
    }
  },

  computed: {
    assets () {
      return this.$store.state.assetLibrary.assets
    },

    dragOptions() {
      return {
        animation: 120,
        group: "contentBg",
        disabled: false,
        ghostClass: "ghostly"
      }
    },

    highestId () {
      let ids = [0];

      this.editableBgContent.forEach((bg) => {
        if (!isNaN(bg._id)) {
          ids.push(bg._id)
        }        
      });

      return (Math.max(...ids) + 1).toString();
    },
  },

  methods: {
   addBgContent() {
      const newBgContent = {
        _id: this.highestId,
        heading: {
          en: ''
        },
        description: {
          en: ''
        },
        image: ""
      }

      this.editableBgContent.push(newBgContent)
    },

    updateBgContent() {
      this.isBgContentSelected = false;
      console.log('new shit ', this.editableBgContent)
      this.$emit('updateBgContent', this.editableBgContent)
    },

    removeBgContent(id) {
      this.isBgContentSelected = false;

      let remainingBgContent = this.editableBgContent.filter(function(item) {
        if (item._id != id) {
          return item
        }
      });

      this.editableBgContent = remainingBgContent
      this.$emit('updateBgContent', this.editableBgContent)
    },

    bgContentSelected(event, item) {
      this.isBgContentSelected = true;

      const modalWidth = 125;

      let modalLeft = event.target.offsetLeft + (modalWidth / 2);
      let modalTop = event.target.offsetTop + event.target.offsetHeight + 7;

      console.log("item", item)
      this.modalData.assetSelected.content = item
      this.modalData.assetSelected.type = 'backgroundContent'
      this.modalData.assetSelected.xPos = modalLeft
      this.modalData.assetSelected.yPos = modalTop
    },

    bgContentDeselected() {
      this.isBgContentSelected = false;
    },

    closeAssetLibrary () {
      this.isLibraryVisible = false
    },

    openAssetLibrary () {
      if (!this.disabled)
        this.isLibraryVisible = true
    },

    initLibraryModel () {
      if (this.assets.length) {
        if (this.multiple) {
          let libraryModel = []
          this.value.forEach(path => {
            libraryModel.push(_.find(this.assets, asset => {
              return asset.path === path
            }))
          })
          this.libraryModel = libraryModel
        } else {
          this.libraryModel = _.find(this.assets, asset => {
            return asset.path === this.value
          })
        }
      }
    },

    removeAsset () {
      this.modalData.assetSelected.content.image = ''
    },

    convertToThumbnail (path) {
      const paths = path.split('/')
      if (path.substring(path.lastIndexOf('.')+1, path.length) == 'mp4') {
        return paths[0] + '/thumb_' + paths[1] + '.jpg'
      } else {
        return paths[0] + '/thumb_' + paths[1]
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.background-content-wrapper {
  position: relative;
}

.background-content-list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}

.background-content {
  background-size: cover;
  border-radius: 4px;
  cursor: move;
  font-size: 2.5px;
  height: calc(980px / 4);
  margin: 10px;
  position: relative;
  width: calc(1520px / 4);

  &--no-bg {
    background-position: 0px 0px, 10px 10px;
    background-size: 20px 20px;
    background-image: 
    linear-gradient(45deg, #eee 25%, transparent 25%, transparent 75%, #eee 75%, #eee 100%),
    linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
  }

  .heading {
    font-size: 5em;
    font-weight: 500;
    color: #fff;
    position: absolute;
    top: 1em;
    left: 1em;
    letter-spacing: .1em;
    line-height: 1;
    padding-top: .5em;
    text-shadow: 0 0 5px rgba(0,0,0,.5);

    &::before {
      content: "";
      width: 2.5em;
      height: .25em;
      background-color: #2faae1;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

.modal-label {
  color: #ffffff;
}
</style>